// Stable color per cost component so every calculation/audit popup traces
// consistently (owner: "know where every number comes from"). Contingency = blue.
export const COST_COLORS = {
  labor: "#4338CA",
  material: "#0F766E",
  equipment: "#B45309",
  per_diem: "#7C3AED",
  subcontract: "#DB2777",
  mobilization: "#0369A1",
  general_conditions: "#4D7C0F",
  management: "#9333EA",
  direct: "#334155",
  contingency: "#2563EB",
  profit: "#059669",
  bond: "#CA8A04",
  warranty: "#DC2626",
  tax: "#64748B",
  environmental: "#65A30D",
  allowances: "#0891B2",
  total: "#0F172A",
};

export const COST_LEGEND = [
  ["labor", "Labor"],
  ["material", "Material"],
  ["equipment", "Equipment"],
  ["per_diem", "Per-diem"],
  ["subcontract", "Subcontract"],
  ["mobilization", "Mobilization"],
  ["general_conditions", "General Conditions"],
  ["management", "Management"],
  ["allowances", "Allowances"],
  ["direct", "Direct cost"],
  ["contingency", "Contingency"],
  ["profit", "Profit"],
  ["bond", "Bond"],
  ["warranty", "Warranty"],
];
